import React, { useEffect, useState } from 'react'
import { SEASON_SEGMENT_NAMES, getShortMarket, logEvent } from '../../../../../../Utils'
import { EventGQL } from '../../../../../../Api'
import { MAIN_PLL_URL, PLL_LINKS } from '../../../../../../Config/config'
import { logBrazeEvent } from '../../../../../../Utils/analytics/brazeAnalytics'
import { marketPresales } from '../../../../../../Config/Season/season'
import { ANALYTICS_TAGS } from '../../../../../../Constants/analytics'
import * as Icons from '../../../../../../Components/Icons'
import { HeadItem } from '../../../../schedStyles'
import { colors } from '../../../../../../Components/consts'

type TicketDropdownType = {
  event: EventGQL
  week: string
  waitList: boolean
  uiTheme?: 'light' | 'dark'
}

export const TicketsIconButton: React.FC<
  React.PropsWithChildren<TicketDropdownType>
> = ({ event, week, waitList, uiTheme }) => {
  let shortMarket = getShortMarket(event)
  const [ticketLink, setTicketLink] = useState<string>('')

  useEffect(() => {
    const tUrl = createTicketsLink()
    setTicketLink(tUrl)
  }, [])

  const createTicketsLink = () => {
    if (event.seasonSegment === SEASON_SEGMENT_NAMES.champseries) {
      return PLL_LINKS.championshipSeriesTickets
    }
    if (event.seasonSegment === SEASON_SEGMENT_NAMES.post) {
      shortMarket = getShortMarket(event)
    }
    if (waitList) return marketPresales[shortMarket.toLowerCase()]
    return shortMarket
      ? `https://${MAIN_PLL_URL}/${shortMarket.toLowerCase()}?utm_medium=Schedule_Page&utm_source=Web_Main`
      : ''
  }
  const log = (name: string, params: any) => {
    logEvent(name, params)
    logBrazeEvent(name, params)
  }

  return (
    <>
      {ticketLink && (
        <HeadItem
          href={ticketLink}
          uiTheme={uiTheme}
          aria-label="List tickets"
          onClick={() => {
            log(ANALYTICS_TAGS.tickets_click, {
              week: `${week}`,
              market: shortMarket,
              ticketUrl: ticketLink,
            })
          }}
        >
          <Icons.Tickets className="icon" fill={colors.text} />
          <p>Tickets</p>
        </HeadItem>
      )}
    </>
  )
}
